<form [formGroup]="filterForm" class="row col-12">
  <div class="col-12 col-md-6">
    <div class="cell col-12 form-group row" *ngIf="soldTos && showSelectCustomers">
      <eps-select
        [options]="soldTos"
        label="ORDERS.FILTER.LABELS.CUSTOMER"
        formControlName="soldToId"
        autoSelect
        [showErrors]="false"
        hideOptionalMarker
      ></eps-select>
    </div>
    <div class="cell col-12 form-group row">
      <eps-select
        formControlName="invoiceType"
        [options]="invoiceTypes"
        [showErrors]="false"
        hideOptionalMarker
        [clearable]="true"
        label="INVOICES.FILTER.LABELS.TYPE"
      ></eps-select>
    </div>
    <div class="cell col-12 form-group row">
      <eps-text-input
        label="INVOICES.FILTER.LABELS.NUMBER"
        formControlName="invoiceNumber"
        [showErrors]="false"
        hideOptionalMarker
      ></eps-text-input>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <ng-container *ngIf="(showDatesIn2rows$ | async); else showUnloadingDatesIn1row">
      <div class="cell col-12 form-group row">
        <eps-date-input
          formControlName="invoiceDateFrom"
          label="INVOICES.FILTER.LABELS.BILLING_DATE_FROM"
          [showErrors]="false"
          hideOptionalMarker
          outputFormat="yyyy-MM-dd"
          [max]="filterForm.value.invoiceDateTo"
        ></eps-date-input>
      </div>
      <div class="cell col-12 form-group row">
        <eps-date-input
          formControlName="invoiceDateTo"
          label="INVOICES.FILTER.LABELS.BILLING_DATE_TO"
          [showErrors]="false"
          hideOptionalMarker
          outputFormat="yyyy-MM-dd"
          [min]="filterForm.value.invoiceDateFrom"
          [max]="now"
        ></eps-date-input>
      </div>
    </ng-container>
    <ng-template #showUnloadingDatesIn1row>
      <div class="cell col-12 form-group row">
        <eps-label-body label="INVOICES.FILTER.LABELS.BILLING_DATE">
          <div class="eps-body">
            <eps-date-input
              formControlName="invoiceDateFrom"
              labelPosition="none"
              [showErrors]="false"
              hideOptionalMarker
              [max]="now"
            ></eps-date-input>
            <eps-date-input
              formControlName="invoiceDateTo"
              labelPosition="none"
              [showErrors]="false"
              [max]="now"
              hideOptionalMarker
            ></eps-date-input>
          </div>
        </eps-label-body>
      </div>
    </ng-template>
    <ng-container *ngIf="(showDatesIn2rows$ | async); else showNetAmountIn1row">
      <div class="cell col-12 form-group row">
        <eps-number-input
          formControlName="invoiceNetAmountFrom"
          label="INVOICES.FILTER.LABELS.AMOUNT_FROM"
          [showErrors]="false"
          hideOptionalMarker
          [maxDecimals]="2"
          decimalPoint=","
        ></eps-number-input>
      </div>
      <div class="cell col-12 form-group row">
        <eps-number-input
          formControlName="invoiceNetAmountTo"
          label="INVOICES.FILTER.LABELS.AMOUNT_TO"
          [showErrors]="false"
          hideOptionalMarker
          decimalPoint=","
          [maxDecimals]="2"
        ></eps-number-input>
      </div>
    </ng-container>
    <ng-template #showNetAmountIn1row>
      <div class="cell col-12 form-group row">
        <eps-label-body label="INVOICES.FILTER.LABELS.AMOUNT">
          <div class="eps-body">
            <eps-number-input
              formControlName="invoiceNetAmountFrom"
              labelPosition="none"
              [showErrors]="false"
              hideOptionalMarker
              [maxDecimals]="2"
              decimalPoint=","
            ></eps-number-input>
            <eps-number-input
              formControlName="invoiceNetAmountTo"
              labelPosition="none"
              [showErrors]="false"
              hideOptionalMarker
              [maxDecimals]="2"
              decimalPoint=","
            ></eps-number-input>
          </div>
        </eps-label-body>
      </div>
    </ng-template>
  </div>
</form>
